import {
  REPLACE_POPUP,
  PUSH_POPUP,
  CLOSE_ALL_POPUPS,
  CLOSE_ACTIVE_POPUP,
  CLOSE_TARGET_POPUP,
  REPLACE_ACTIVE_POPUP,
} from './constants';

const formPopup = (data) => ({ ...data, id: `${Math.random()}` });

// eslint-disable-next-line default-param-last
export function popup(state = [], action) {
  const { type, payload } = action;
  switch (type) {
    case CLOSE_ALL_POPUPS: {
      return [];
    }
    case CLOSE_ACTIVE_POPUP: {
      return state.slice(0, -1);
    }
    case CLOSE_TARGET_POPUP: {
      return [...state.slice(0, payload), ...state.slice(payload + 1)];
    }
    case PUSH_POPUP: {
      return [...state, formPopup(payload)];
    }
    case REPLACE_POPUP: {
      return [payload];
    }
    case REPLACE_ACTIVE_POPUP: {
      return [...state.slice(0, -1), formPopup(payload)];
    }
    default:
      return state;
  }
}
